import { ObservableArray, View } from "binder"
import { PurchaseProcessStateEnumProvider, PurchaseProcessViewModel, singleProcess } from "./purchaseProcess-viewModel"

export class PurchaseProcessView extends View<PurchaseProcessViewModel>{
    GetViewUniqueId(): string {
        return "V-A1B14600-B3D0-4714-B6A9-9316E3BC26B1"
    }
    loadHtml(): string {
        let element = require('./purchaseProcess.html').default;
        let style = require('./purchaseProcess.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleProcess>) { this._items = v; } public get items(): ObservableArray<singleProcess> { return this._items;} private _items: ObservableArray<singleProcess>;
    public set selectedProcess(v: singleProcess) { this._selectedProcess = v; } public get selectedProcess(): singleProcess { return this._selectedProcess;} private _selectedProcess: singleProcess;
    public set stateEnumProvider(v: PurchaseProcessStateEnumProvider) { this._stateEnumProvider = v; } public get stateEnumProvider(): PurchaseProcessStateEnumProvider { return this._stateEnumProvider;} private _stateEnumProvider: PurchaseProcessStateEnumProvider;
    public set containerNo(v: string) { this._containerNo = v; } public get containerNo(): string { return this._containerNo;} private _containerNo: string;
    
    search() {
        this.dataContext.search();
    }
    
    refresh() {
        this.dataContext.refresh();
    }

    createNew(){
        this.dataContext.createNew();
    }
}
